import { ChevronsUpDown, PlusIcon } from 'lucide-react';
import { Select as SelectPrimitive } from 'radix-ui';
import { Button } from '@/shared/components/ui/button';
import { Select, SelectContent, SelectItem, SelectValue } from '@/components/ui/select';
import { Link } from 'react-router-dom';
import { paths } from '@/config/paths';

type Option = {
  label: string;
  value: string;
};

type SaleSelectProps = {
  value: string;
  onChange: (value: string) => void;
  options: Option[];
  showCreateSale?: boolean;
};

export function SaleSelect({ value, onChange, options, showCreateSale }: SaleSelectProps) {
  const selectedLabel = options.find((option) => option.value === value)?.label;

  return (
    <Select defaultValue={value} onValueChange={onChange} value={value}>
      <SelectPrimitive.SelectTrigger aria-label="Välj försäljning" asChild>
        <Button variant="ghost" className="h-8 p-1.5 text-foreground focus-visible:bg-accent focus-visible:ring-0">
          <SelectValue placeholder="Välj försäljning">{selectedLabel}</SelectValue>
          <ChevronsUpDown size={14} className="text-muted-foreground/80" />
        </Button>
      </SelectPrimitive.SelectTrigger>
      <SelectContent className="[&_*[role=option]]:ps-2 [&_*[role=option]]:pe-8 [&_*[role=option]>span]:start-auto [&_*[role=option]>span]:end-2">
        {options.map((option) => (
          <SelectItem value={option.value}>{option.label}</SelectItem>
        ))}

        {showCreateSale && (
          <>
            <div className="border-t my-1" />

            <Link
              to={paths.sales.create.getHref()}
              className="flex cursor-pointer select-none items-center gap-2 px-2 py-1.5 text-sm hover:bg-accent hover:text-accent-foreground rounded-sm"
              onClick={(e) => e.stopPropagation()}
            >
              <PlusIcon size={16} className="opacity-60" aria-hidden="true" />
              Starta försäljning
            </Link>
          </>
        )}
      </SelectContent>
    </Select>
  );
}
